/* tslint:disable */
export const TAX_SAVER_PLANS = require('./bucketData/bucket19.json');



// WEBPACK FOOTER //
// ./constants/fundBuckets/taxSaver.ts